
import {Component, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";
import EditUser from "@/components/users/EditUser.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiNfcVariant } from "@mdi/js";
import UserBadgeNfc from "@/components/users/UserBadgeNfc.vue";
import DisableNotificationBySmsAndMail from "@/components/DisableNotificationBySmsAndEmail.vue";

@Component({
    components: {
        EditUser,
        SvgIcon,
        UserBadgeNfc,
        DisableNotificationBySmsAndMail,
    },
})
export default class UserMobile extends Vue {
    @Getter private currentUser: any;
    @Getter private canDoInEnvCompany: (right: string) => boolean;

    private user: any = null;
    private userId: number = null;
    private isLoading: boolean = true;
    private mdiNfcVariant = mdiNfcVariant;
    private displayUserBadgeNFC: boolean = false;

    get isMyPage(): boolean {
        return this.currentUser.id === this.userId;
    }

    get canEditProfile(): boolean {
        // Only if this is the current user's page, or the current user is Admin
        return this.isMyPage || this.currentUser.isAdmin;
    }

    get canCreateBadge(): boolean {
      return this.canDoInEnvCompany("BADGE_NFC_MANAGEMENT"); // a discuter
    }

    private mounted() {
        this.reset();
    }

    private showUserBadgeNfc() {
      this.displayUserBadgeNFC = true;
    }

    private closeUserBadgeNfc() {
      this.displayUserBadgeNFC = false;
    }

    private reset() {
        this.userId = Number(this.$route.params.id);
        this.getUserById();
    }

    private getUserById() {
        this.isLoading = true;
        return this.$store.dispatch("users/getUserById", {
            id: this.userId,
        }).then((user) => {
            this.user = user;
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err,
            });
        }).finally(() => {
            this.isLoading = false;
        });
    }
}
